import { get } from './axios.js'

let api = '/api'

export const getHeaderMenu = query => get(api + '/columnTreeList?' + (query || ''))
